import { usePostContentContext } from '@/postContentElement';

import { embedDescriptionContainer, embedDescriptionParagraph } from './GenericEmbedDescription.css';
import type { TPostGenericEmbedDescriptionProps } from './GenericEmbedDescription.types';

export const PostGenericEmbedDescription = ({ element }: TPostGenericEmbedDescriptionProps) => {
  const { postTheme } = usePostContentContext();

  if (!element?.content?.[0]?.text || postTheme?.hyperlink_hide_description === 'true') {
    return null;
  }

  return (
    <div className={embedDescriptionContainer}>
      <p className={embedDescriptionParagraph}>{element.content[0].text}</p>
    </div>
  );
};
